import { schema } from 'normalizr'
import { Record, Map } from 'immutable'
import { events } from './events'
import { places } from './places'
import { users } from './users'
import { currencies } from './statics'

const _schema = new schema.Entity('batchedBookings', {
  event: events.schema,
  place: places.schema,
  user: users.schema,
})

const _Record = Record({
  id: undefined,

  created_at: undefined,
  date: undefined,
  event_id: undefined,
  event: new events.Record(),
  user_id: undefined,
  user: new users.Record(),
  status: undefined,
  place: new places.Record(),
  payment: new Map({
    user_currency: new currencies.Record(),
    total_paid: undefined,
  }),
  reference_code: undefined,
})

export const batchedBookings = {
  schema: _schema,
  Record: _Record,
}
